import { getMenuIcon } from "../../../utils/helpers";
import React, { SyntheticEvent } from "react";
import { Nav } from "rsuite";

const TopMenu = ({
  menu,
  onSelect,
  activePath,
}: {
  menu: any;
  onSelect: any;
  activePath: string;
}) => {
  return (
    <Nav>
      {menu.map((item: any) => {
        let menuIcon = getMenuIcon(item?.menu_icon);

        let parentIcon = menuIcon ? { ["icon"]: menuIcon } : {};
        return item.child.length <= 0 ? (
          <Nav.Item
            key={item.menu_url}
            eventKey={item.menu_url}
            onSelect={(
              eventKey: string | undefined,
              event: SyntheticEvent<Element, Event>
            ) => {
              onSelect(eventKey, item.page_type);
            }}
            {...parentIcon}
          >
            {item.menu_label}
          </Nav.Item>
        ) : (
          <Nav.Menu
            key={"4"}
            eventKey={"4"}
            trigger="hover"
            title={item.menu_label}
            {...parentIcon}
          >
            {item.child.map((child: any) => {
              let childMenuIcon = getMenuIcon(child?.menu_icon);

              let childIcon = childMenuIcon ? { ["icon"]: childMenuIcon } : {};
              return (
                <Nav.Item
                  key={child.menu_url}
                  active={activePath === `/${child.menu_url}`}
                  onSelect={(
                    eventKey: string | undefined,
                    event: SyntheticEvent<Element, Event>
                  ) => {
                    onSelect(eventKey, child.page_type);
                  }}
                  eventKey={child.menu_url}
                  {...childIcon}
                >
                  {child.menu_label}
                </Nav.Item>
              );
            })}
          </Nav.Menu>
        );
      })}
    </Nav>
  );
};

export default TopMenu;
